"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  'Add "{inputValue}"': ['"', ["inputValue"], '" を追加'],
  "All items have been removed.": "すべてのアイテムが削除されました。",
  "Clear selection": "選択のクリア",
  "No results found.": "何も見つかりませんでした。",
  "Press Enter to select or deselect an option.": "Enter キーを押してオプションを選択または選択解除します。",
  "Select All": "すべて選択",
  "Selected Items": "選択したアイテム",
  "Toggle menu": "メニューの切り替え",
  "listbox contents": "リストボックスの内容",
  "{itemAsString} has been removed.": ['"', ["itemAsString"], '" が削除されました。'],
  "{itemAsString} has been selected.": ['"', ["itemAsString"], '" が選択されました。'],
  "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.": [["resultCount", "plural", {
    one: ["#", " 件の結果"],
    other: ["#", " 件の結果"]
  }], "があります。移動するには上下矢印キーを使用します。 Enter キーを押して選択します。"],
  "{selectedValue} selected": [["selectedValue"], " 個選択"],
  "{totalSelectedItems} selected": [["totalSelectedItems"], " 個選択済み"],
  "{totalSelectedItems} selected. Deselect all": [["totalSelectedItems"], " 個選択済み。 すべて選択解除"],
  "{totalSelectedItems} selected. Select all {totalOptions} items": [["totalSelectedItems"], " 個選択済み。 ", ["totalOptions"], " アイテムをすべて選択"]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map